module.exports = __webpack_public_path__ + "img/Grupo 252.dd895d70.png";